'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyConnecture } from '../../Entities/Agency/AgencyConnecture';
import { AgencyConnectureCollection } from '../../Collections/Agency/AgencyConnectureCollection';

export class AgencyConnectureRepository extends CoreRepository {
  public getAgencyConnecture(userId: number, agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyConnecture(userId, agencyId, options).then((response) => {
      const collection = new AgencyConnectureCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyConnecture();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addAgencyConnecture(userId: number, agencyId, payload: any[]) {
    return this.webAPI.addAgencyConnecture(userId, agencyId, payload).then((response) => {
      const item = new AgencyConnecture();
      item.hydrate(response);

      return item;
    });
  }

  public updateAgencyConnecture(userId: number, agencyId: number, urlId: number, payload: any[]) {
    return this.webAPI.updateAgencyConnecture(userId, agencyId, urlId, payload).then((response) => {
      return response;
    });
  }

  public deleteAgencyConnecture(userId: number, agencyId: number, urlId: number) {
    return this.webAPI.deleteAgencyConnecture(userId, agencyId, urlId).then((response) => {
      return response;
    });
  }
}
